import { Lesson, Class } from '@all-for-one/shared-types'
import { PrintOverlay } from './print-overlay'
import { AnswerKeyPdfDocument } from './pdf-draft-answer-key'

interface PrintAnswerKeyOverlayProps {
    lesson: Lesson
    className?: string
    gradeBand?: string
    subject?: string
    classData?: Class
    onDismiss: () => void
}

export const PrintAnswerKeyOverlay = (props: PrintAnswerKeyOverlayProps) => (
    <PrintOverlay
        {...props}
        PdfDocument={AnswerKeyPdfDocument}
        filenameSuffix="answer_key"
        headerText="Download Answer Key"
        organizeStepHeading="How should questions be sorted?"
    />
)
